import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import ModalComponent from '../Modal/Modal/ModalComponent';
import ReceivedVehicleModal from './ReceivedVehicleModal/ReceivedVehicleModal';
import { TOGGLE_MODAL } from '../../redux/Modal';
import BuyNowModal from '../AuctionForm/BuyNowModal';
import PromotionFormModal from '../Promotions/PromotionFormModal';
import UpdatePromotionModal from '../Promotions/UpdatePromotionModal';
import NewPasswordModal from '../Authentication/NewPasswordModal';
import PasswordUpdatedModal from '../Authentication/PasswordUpdatedModal';

const modalInnerComponents = {
  ReceivedVehicleModal,
  BuyNowModal,
  PromotionFormModal,
  UpdatePromotionModal,
  NewPasswordModal,
  PasswordUpdatedModal
};

class Modal extends PureComponent {
  closeModal = () => {
    this.props.toggleModal({ value: false });
  }

  render() {
    const { isVisible, overlayClosesModal, isCloseButtonShown, componentName, modalTmpData, customContentClass } = this.props;
    const ModalInnerComponent = modalInnerComponents[componentName];
    return (
      <ModalComponent
        isVisible={isVisible}
        overlayClosesModal={overlayClosesModal}
        isCloseButtonShown={isCloseButtonShown}
        closeModal={this.closeModal}
        customContentClass={customContentClass}
        child={ModalInnerComponent ? <ModalInnerComponent data={modalTmpData} closeModal={this.closeModal} /> : <span />}
      />
    );
  }
}

Modal.propTypes = {
  // redux
  toggleModal: PropTypes.func.isRequired,
  isVisible: PropTypes.bool,
  overlayClosesModal: PropTypes.bool,
  isCloseButtonShown: PropTypes.bool,
  componentName: PropTypes.string,
  customContentClass: PropTypes.string,
  modalTmpData: PropTypes.objectOf(PropTypes.any),
};

Modal.defaultProps = {
  isVisible: null,
  overlayClosesModal: null,
  isCloseButtonShown: null,
  componentName: null,
  customContentClass: '',
  modalTmpData: null,
};

const mapStateToProps = (state) => {
  return {
    isVisible: get(state, ['modal', 'isVisible']),
    overlayClosesModal: get(state, ['modal', 'overlayClosesModal']),
    isCloseButtonShown: get(state, ['modal', 'isCloseButtonShown']),
    componentName: get(state, ['modal', 'componentName']),
    customContentClass: get(state, ['modal', 'customContentClass']),
    modalTmpData: get(state, ['modal', 'modalTmpData']),
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    toggleModal: value => dispatch(TOGGLE_MODAL(value)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Modal);
